import { render, staticRenderFns } from "./EnterpriseTable.vue?vue&type=template&id=15b6d550"
import script from "./EnterpriseTable.vue?vue&type=script&lang=js"
export * from "./EnterpriseTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports